import React from "react";
import RegistrationBox from "../../common/registration_box";
import styles from "./blog_registration.module.scss";

export const BlogRegistration = () => {
  return (
    <section className={styles.section_blog_registration}>
      <div className="container">
        <RegistrationBox />
      </div>
    </section>
  );
};

export default BlogRegistration;
